import { useTranslation } from 'react-i18next';
import { format, addDays, subDays, subWeeks, subMonths, subYears, addMonths, addWeeks } from 'date-fns';
import { isoDateFormat } from '../../../../core/utils/dates.ts';
import { camelCase } from 'lodash';
import * as React from 'react';
import DateRangePresetFilter from '../../../../core/components/DateRangePresetFilter.tsx';

const PastDateFilter = ({ filters, onFiltersChange, filterName }) => {
    const { t } = useTranslation('assistance');
    const today = new Date();

    const presetOptions = [
        {
            label: t('overview.filters.createdAt.options.today'),
            value: [format(today, isoDateFormat), format(today, isoDateFormat)].join(','),
        },
        {
            label: t('overview.filters.createdAt.options.yesterday'),
            value: [format(subDays(today, 1), isoDateFormat), format(subDays(today, 1), isoDateFormat)].join(','),
        },
        {
            label: t('overview.filters.createdAt.options.lastWeek'),
            value: [format(subWeeks(today, 1), isoDateFormat), format(today, isoDateFormat)].join(','),
        },
        {
            label: t('overview.filters.createdAt.options.lastMonth'),
            value: [format(subMonths(today, 1), isoDateFormat), format(today, isoDateFormat)].join(','),
        },
        {
            label: t('overview.filters.createdAt.options.last3Months'),
            value: [format(subDays(today, 90), isoDateFormat), format(today, isoDateFormat)].join(','),
        },
        {
            label: t('overview.filters.createdAt.options.last6Months'),
            value: [format(subMonths(today, 6), isoDateFormat), format(today, isoDateFormat)].join(','),
        },
        {
            label: t('overview.filters.createdAt.options.lastYear'),
            value: [format(subYears(today, 1), isoDateFormat), format(today, isoDateFormat)].join(','),
        },
    ];

    return (
        <DateRangePresetFilter
            filters={filters}
            onFiltersChange={onFiltersChange}
            filterName={filterName}
            label={t(`overview.filters.${camelCase(filterName)}.label`)}
            presetOptions={presetOptions}
            maxDate={today}
        />
    );
};

export const FutureDateFilter = ({ filters, onFiltersChange, filterName }) => {
    const { t } = useTranslation('assistance');
    const today = new Date();

    const presetOptions = [
        {
            label: t('overview.filters.createdAt.options.overdue'),
            value: [format(subMonths(today, 6), isoDateFormat), format(subDays(today, 1), isoDateFormat)].join(','),
        },
        {
            label: t('overview.filters.createdAt.options.today'),
            value: [format(today, isoDateFormat), format(today, isoDateFormat)].join(','),
        },
        {
            label: t('overview.filters.createdAt.options.tomorrow'),
            value: [format(addDays(today, 1), isoDateFormat), format(addDays(today, 1), isoDateFormat)].join(','),
        },
        {
            label: t('overview.filters.createdAt.options.nextWeek'),
            value: [format(addWeeks(today, 1), isoDateFormat), format(today, isoDateFormat)].join(','),
        },
        {
            label: t('overview.filters.createdAt.options.nextMonth'),
            value: [format(addMonths(today, 1), isoDateFormat), format(today, isoDateFormat)].join(','),
        },
        {
            label: t('overview.filters.createdAt.options.next3Months'),
            value: [format(addDays(today, 90), isoDateFormat), format(today, isoDateFormat)].join(','),
        },
    ];

    return (
        <DateRangePresetFilter
            filters={filters}
            onFiltersChange={onFiltersChange}
            filterName={filterName}
            label={t(`overview.filters.${camelCase(filterName)}.label`)}
            presetOptions={presetOptions}
        />
    );
};

export default PastDateFilter;
